import { MenuItemType } from '../../../utils/types'
import { Button, EditableVideo, WContainer, WImage } from '../../atoms'
import { ArrowRight } from '../../icons'
import styles from './HeroHomeSlide.module.sass'

interface Props {
  className?: string
  item?: MenuItemType
  variant?: 'default' | 'rounded'
  editMode?: boolean
  index?: number
}

const HeroHomeSlide = (props: Props) => {
  const {
    className = '',
    item = undefined,
    variant = 'default',
    editMode = false,
    index = 0,
  } = props

  return (
    <div
      className={`${styles.root} ${className} ${styles[`root--${variant}`] || ''} ${
        item.video?.ratio ? styles[`root--video-${item.video.ratio.replace(':', '-')}`] : ''
      }`}
    >
      <div className={styles.mediaBox}>
        {item?.image ? (
          <WImage
            src={item.image}
            alt={item?.imageAlt}
            maxWidth={1920}
            maxHeight={680}
            objectFit="cover"
            priority={index === 0}
            loading={index === 0 ? 'eager' : 'lazy'}
          />
        ) : item?.video ? (
          <EditableVideo
            item={{
              ...item.video,
              autoplay: true,
              muted: true,
              controls: false,
              loop: true,
              related: false,
            }}
          />
        ) : null}
      </div>
      <WContainer className={styles.containerMain}>
        <div className={styles.main}>
          <h2 className={styles.title}>{item.name}</h2>
          <Button
            label={item.ctaLabel}
            href={item.url}
            icon={<ArrowRight />}
            iconPos="right"
            variant="ghost"
            theme="dark"
          />
        </div>
      </WContainer>
      <div className={styles.overlay} />
    </div>
  )
}

export default HeroHomeSlide
